<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="130px">
        <el-form-item label="基础金币额度:" prop="amount">
          <el-input v-model.number="params.amount" size="small"></el-input>
        </el-form-item>
        <el-form-item label="优惠额度:" prop="incrAmount">
          <el-input v-model.number="params.incrAmount" size="small"></el-input>
        </el-form-item>
        <el-form-item label="优惠率:" prop="incTax">
          <el-input v-model="params.incTax" size="small"></el-input>
        </el-form-item>
        <el-form-item label="支付方式:" prop="type">
          <el-input
            v-model="params.type"
            size="small"
            disabled
          >{{params.type= this.params.typeName=='微信'?'wechat':(this.params.typeName=='支付宝'?'alipay':(this.params.typeName=='代充'?'daichong':''))}}</el-input>
        </el-form-item>
        <el-form-item label="支付类型:" prop="typeName">
          <el-select v-model="params.typeName" size="small">
            <el-option
              v-for="item in typeNameList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";

export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      flag: false,
      id: "",
      params: {
        amount: "",
        incrAmount: "",
        incTax: "",
        type: "",
        typeName: "",
      },
      typeList: [
        { label: "wechat", value: "wechat" },
        { label: "alipay", value: "alipay" },
        { label: "daichong", value: "daichong" },
      ],
      typeNameList: [
        { label: "微信", value: "微信" },
        { label: "支付宝", value: "支付宝" },
        { label: "代充", value: "代充" },
      ],

      rules: {
        amount: [
          { required: true, message: "请输入金币额度", trigger: "blur" },
        ],
        incrAmount: [
          { required: true, message: "请输入优惠额度", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择充值方式", trigger: "blur" }],
        typeName: [
          { required: true, message: "请选择充值类型", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 提交修改
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.title === "新增金币支付配置") {
            this.addGold();
          } else {
            this.editGold();
          }
        } else {
          return false;
        }
      });
    },
    // 修改金币配置
    editGold() {
      let params = Object.assign({}, this.params, {
        id: this.id,
        incTax: parseFloat(this.params.incTax),
      });
      API.updatePayGold(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改金币支付配置成功",
              type: "success",
            });
            this.$emit("handlerGoldList");
          } else {
            this.$message.error("修改金币支付配置失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 添加金币配置
    addGold() {
      let params = Object.assign({}, this.params, {
        amount: this.params.amount,
        type:
          this.params.typeName == "微信"
            ? "wechat"
            : this.params.typeName == "支付宝"
            ? "alipay"
            : "daichong",
        typeName: this.params.typeName,
        incTax: parseFloat(this.params.incTax),
      });
      API.addPayGold(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增金币支付配置成功",
              type: "success",
            });
            this.$emit("handlerGoldList");
          } else {
            this.$message.error("新增金币支付配置失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        amount: "",
        incrAmount: "",
        incTax: "",
        type: "",
        typeName: "",
      };
      this.$refs["form"].resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑金币支付配置";
        this.params.amount = data.amount;
        this.params.incrAmount = data.incrAmount;
        this.params.incTax = parseFloat(data.incTax);
        this.params.type = data.type;
        this.params.typeName = data.typeName;
        this.id = data.id;
      } else {
        this.title = "新增金币支付配置";
      }
    },
  },
};
</script>

<style lang="scss" >
.add-pay-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
